export default __webpack_public_path__ + "static/media/equalitySign.c0823489.svg";